import React,{useEffect,useState,useRef} from 'react';
import { Row, Col, Container, Accordion } from 'react-bootstrap';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Breadcrumb from '../Breadcrumbs';
import ProductListSidebar from '../ProductListSidebar';
import ProductListLeftbar from '../ProductListLeftbar';
import BrandLogoSlider from '../BrandLogoSlider';
import Axios from '../../lib/axios/axiosInstance';
import { useSelector, useDispatch } from 'react-redux'
import './ProductList.styles.css';

const ProductList = ({ baseUrl, url,productBasename,leftUrl }) => {
  
	const [products, setProducts] = useState(false);
	const [compareProductListUpdated, setCompareProductListUpdated] = useState(0);
	const [leftSideData, setLeftSideData] = useState(false);
	const [productBname, setProductBname] = useState(false);
	const [filter, setFilter] = useState(false);
  const colorFilter = useRef('');

  const compare = useSelector(state => state.compare);
  const dispatch = useDispatch();

  useEffect(() => {
    if(compare && compare>0){
      setCompareProductListUpdated(compare)
    }
  }, [compare])

  const getProducts = async (firstTime=false) => {
  let requestUrl=firstTime?`${url}${colorFilter.current}&sortby=matname&orderby=asc`:`${url}${colorFilter.current}`;
  await Axios.get(requestUrl)
    .then(function (response) {
      if (response && response.status == 200) {
        var data=response.data;
        setProducts(data[0]);
      }
    })
  };

  const colorFilterHandler=(filter)=>{
    setProducts([])
    colorFilter.current=filter;
    setFilter(filter)
    // getProducts();
  }

  const getLeftSidesData = async () => {
    await Axios.get(leftUrl)
    .then(function (response) {
      if (response?.data && response.status == 200) {
        var data=response.data;
        setLeftSideData(data);
      }
    })
  };

  useEffect(() => {
    setProducts([])
    if(url)getProducts(true);
    if(leftUrl)getLeftSidesData()
	}, [url])

  useEffect(() => {
    if(productBasename)setProductBname(productBasename);
  }, [productBasename])

  return (
    <>
      {/* <Breadcrumb /> */}
        <section className="main-container col2-left-layout">
          <Container>
            <Row>
              {isMobile && <Col sm={3} md={3} xs={12} lg={3} className="col-sm-pull-9 sidebar">
                <ProductListSidebar colorFilterHandler={colorFilterHandler} leftSideData={leftSideData} compareProductListUpdated={compareProductListUpdated} dispatch={dispatch} isMobile={isMobile}/>
              </Col>}
              <Col sm={9}  md={9} lg={9} className="col-sm-push-3">
                {/* <CustomProductListSideBar/> */}
                <ProductListLeftbar filter={filter} products={products} productBasename={productBname} baseUrl={baseUrl} reducer={compare} dispatch={dispatch}/>
              </Col>
              {isBrowser && <Col sm={3} md={3} xs={12} lg={3} className="col-sm-pull-9 sidebar">
                <ProductListSidebar colorFilterHandler={colorFilterHandler} leftSideData={leftSideData} compareProductListUpdated={compareProductListUpdated} dispatch={dispatch}/>
              </Col>}
              <Col sm={12}>
                <BrandLogoSlider brand={products?.partner}/>
              </Col>
            </Row>
          </Container>
        </section>
    </>
  );
};

export default ProductList;
